var map = {
	"./cca-1.png": 960,
	"./cca-2.png": 197,
	"./cca-3.png": 961,
	"./cca-4.png": 962,
	"./cca-5.png": 963,
	"./cca-6.png": 964
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1622;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/contact ^\.\/cca\-.*\.png$
// module id = 1622
// module chunks = 0